import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const NoEventsFound: React.FC<NormalIconProps> = (props) => (
	<svg
		width="41"
		height="40"
		viewBox="0 0 41 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={props.className}
		onClick={props.onClick}
	>
		<path
			d="M20.4999 9.16772C13.0002 1.37577 3.83325 7.12361 3.83325 15.2285C3.83325 23.3334 10.5323 27.6523 15.4361 31.5181C17.1666 32.8823 18.8333 34.1667 20.4999 34.1667M20.4999 9.16772C27.9997 1.37577 37.1666 7.12361 37.1666 15.2285C37.1666 23.3334 30.4675 27.6523 25.5637 31.5181C23.8333 32.8823 22.1666 34.1667 20.4999 34.1667M20.4999 9.16772L17.9999 14.1667L23.8333 18.3333L18.8333 24.1667L22.1666 27.5L20.4999 34.1667"
			stroke="white"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
